import { Component, OnInit } from '@angular/core';
import { CompanyInformation } from 'src/app/models/company';
import { CompanyService } from 'src/app/services/company.service';
import { environment } from 'src/environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {

  maintenanceDate = environment.maintenanceDate;
  companyInformation: CompanyInformation;

  private _handleError: HandleError;
  private _assetSettings = environment.assets;

  constructor( private _companyService: CompanyService,
               private _errorHandler: ErrorHandler,) {

    this.companyInformation = this._companyService.getNewCompanyInformation();

    this._companyService.companyInformation.subscribe(
      response => (this.companyInformation = response),
      error => this._handleError('companyInformation.subscribe', error)
    );
  }

  ngOnInit() {
  }

  getLogoUrl(): string {
    return this.companyInformation.companyLogoFileName !== null
      ? this._assetSettings.urlPrefix + this.companyInformation.companyLogoFileName
      : 'login';   // 10/25/2021
  }

}
